import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFacebook = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 9,
	height: 20,
	viewBox: "0 0 9 20",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "#001432",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8.23616 10.0072H5.6512C5.6512 14.1146 5.6512 19.1704 5.6512 19.1704H1.8208C1.8208 19.1704 1.8208 14.1636 1.8208 10.0072H0V6.76863H1.8208V4.67387C1.8208 3.17362 2.5376 0.829346 5.6864 0.829346L8.5248 0.840166V3.9839C8.5248 3.9839 6.8 3.9839 6.46464 3.9839C6.12928 3.9839 5.65248 4.15066 5.65248 4.8661V6.76927H8.57088L8.23616 10.0072Z" })
});
export default SvgFacebook;
